var app = angular.module("leonardo");

var ReportsQuickFilters = function(
  $scope,
  $state,
  ReportService,
  $controller
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filter_account = $state.current.account;

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'my_reports_account_filter',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: ($scope.filterService.accounts.length > 1) && !!$scope.filter_account,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        }
      ]
    },
    {
      id: 'report_type',
      name: 'Report Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Types',
      condition: true,
      options: ReportService.TYPE_OPTIONS,
      conflicts: []
    }
  ];

};

app.controller('ReportsQuickFilters', [
  '$scope',
  '$state',
  'ReportService',
  '$controller',
  ReportsQuickFilters
]);
